import actionTypes from 'constants/actionTypes'
import cloneDeep from 'lodash/cloneDeep'
import { isHardFail } from 'lib/action'
import authTypes from 'constants/authTypes'

interface ErrorsState {
  errors: string[]
}

interface ErrorsAction {
  type?: string
  payload?: {
    idx?: number
  }
  error?: {
    status?: number
    config?: {
      method?: string
    }
    response?: {
      status?: number
      statusText?: string
      data?: {
        message?: string
        error?: string
      } | string
    }
  } | string
}

const getErrorString = (error: ErrorsAction['error']): string => {
  if (typeof error === 'string') {
    return error
  }

  const responseData = error?.response?.data
  if (typeof responseData === 'string') {
    return responseData
  }
  if (responseData && typeof responseData === 'object') {
    const message = responseData.message
    if (typeof message === 'string') {
      return message
    }
    const nestedError = responseData.error
    if (typeof nestedError === 'string') {
      return nestedError
    }
  }

  const statusText = error?.response?.statusText
  if (typeof statusText === 'string') {
    return statusText
  }

  return 'Something went wrong!'
}

const initialState: ErrorsState = {
  errors: [],
}

export default (state: ErrorsState = initialState, action: ErrorsAction): ErrorsState => {
  const { type, error } = action
  const errorObj = typeof error === 'string' ? undefined : error
  if (type === actionTypes.ERRORS.RESET_ERROR_MESSAGE) {
    const idx = action.payload?.idx
    if (typeof idx !== 'number') return state
    const updated = cloneDeep(state)
    updated.errors = [
      ...state.errors.slice(0, idx),
      ...state.errors.slice(idx + 1)
    ]
    return updated
  }
  if (errorObj?.config?.method && ['get', 'GET'].includes(errorObj.config.method)) return state
  if (errorObj?.status === 0) return state
  for (const t of authTypes) {
    if (action.type === t.FAIL) return state
  }
  if (error && isHardFail(action)) {
    let errorString = getErrorString(error)
    const updated = cloneDeep(state)
    errorString = `${type}: ${errorString}`
    updated.errors.push(errorString)
    return updated
  }
  return state
}
